// AI-CONTEXT: See docs/features/deep-analysis-period.md
//
// One colour per series key (an answer option) across every compared panel.
// Colouring by position inside each panel made the same option change colour
// between two periods whose options came out in a different order (testronde
// 2026-10-28, B1). The first panel's order decides, new keys from later panels
// follow — so a single panel keeps exactly the colours it always had.

/**
 * @param {Array<Array<string>|null|undefined>} keyLists - Series keys per panel, in each panel's own order
 * @param {Array<string>} palette - Colours to hand out, cycled when they run out
 * @returns {Map<string, string>} Colour per key
 */
const seriesColorMap = (keyLists, palette) => {
    const colors = new Map()
    ;(keyLists || []).forEach((keys) => {
        ;(Array.isArray(keys) ? keys : []).forEach((key) => {
            if (!colors.has(key)) colors.set(key, palette[colors.size % palette.length])
        })
    })
    return colors
}

export default seriesColorMap
